import { render, staticRenderFns } from "./V2Dropdown.vue?vue&type=template&id=8f009d46&scoped=true&"
import script from "./V2Dropdown.vue?vue&type=script&lang=js&"
export * from "./V2Dropdown.vue?vue&type=script&lang=js&"
import style0 from "./V2Dropdown.vue?vue&type=style&index=0&id=8f009d46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f009d46",
  null
  
)

export default component.exports